package net.bothosting.docs.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initSUMMARYPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("SUMMARY.md", FrontMatterElement.EmptyMap))
}

@Page("/summary")
@Layout(".components.layouts.DocsLayout")
@Composable
fun SUMMARYPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("table-of-contents") }) {
        org.jetbrains.compose.web.dom.Text("Table of contents")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/readme") {
                org.jetbrains.compose.web.dom.Text("Bot-hosting.net Guides")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("create-a-discord-bot") }) {
        org.jetbrains.compose.web.dom.Text("Create a Discord Bot")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("create-a-discord-bot/how-to.md") {
                org.jetbrains.compose.web.dom.Text("How to Create a Discord Bot")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("hosting-in-bot-hosting-net") }) {
        org.jetbrains.compose.web.dom.Text("Hosting in Bot-hosting.net")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("hosting-in-bot-hosting.net/create-an-account.md") {
                org.jetbrains.compose.web.dom.Text("Create an Account")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("hosting-in-bot-hosting.net/coin-system-explained.md") {
                org.jetbrains.compose.web.dom.Text("Coin System Explained")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("hosting-in-bot-hosting.net/create-a-server.md") {
                org.jetbrains.compose.web.dom.Text("Create a Server")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("hosting-in-bot-hosting.net/set-up-a-server.md") {
                org.jetbrains.compose.web.dom.Text("Set Up a Server")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("hosting-in-bot-hosting.net/clone-a-git-repository-on-your-server.md") {
                org.jetbrains.compose.web.dom.Text("Clone a Git Repository on Your Server")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("hosting-in-bot-hosting.net/connect-to-your-servers-files-with-sftp.md") {
                org.jetbrains.compose.web.dom.Text("Connect to your server's files with SFTP")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("hosting-in-bot-hosting.net/link-a-domain-to-your-server.md") {
                org.jetbrains.compose.web.dom.Text("Link a Domain to your Server")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("hosting-in-bot-hosting.net/manage-server-subusers.md") {
                org.jetbrains.compose.web.dom.Text("Manage Server Subusers")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("troubleshooting") }) {
        org.jetbrains.compose.web.dom.Text("Troubleshooting")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("troubleshooting/cannot-find-module-modulenotfounderror-no-such-file-or-directory.md") {
                org.jetbrains.compose.web.dom.Text("Cannot find module / ModuleNotFoundError / No such file or directory")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("troubleshooting/invalid-token-has-been-provided-token_invalid.md") {
                org.jetbrains.compose.web.dom.Text("Invalid Token has been provided / TOKEN_INVALID")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("troubleshooting/upload-unarchive-errors.md") {
                org.jetbrains.compose.web.dom.Text("Upload / Unarchive Errors")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("troubleshooting/another-power-action-is-currently-being-processed-for-this-server.md") {
                org.jetbrains.compose.web.dom.Text("Another power action is currently being processed for this server")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("troubleshooting/were-having-some-trouble-connecting-to-your-server.md") {
                org.jetbrains.compose.web.dom.Text("We're having some trouble connecting to your server")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("troubleshooting/an-unexpected-error-was-encountered-while-handling-this-request.md") {
                org.jetbrains.compose.web.dom.Text("An unexpected error was encountered while handling this request")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("troubleshooting/the-requested-resource-does-not-exist-on-this-server.md") {
                org.jetbrains.compose.web.dom.Text("The requested resource does not exist on this server")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("troubleshooting/invalid-elf-header.md") {
                org.jetbrains.compose.web.dom.Text("Invalid ELF Header")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("troubleshooting/better-sqlite-error.md") {
                org.jetbrains.compose.web.dom.Text("Better-sqlite error")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("faqs-and-info") }) {
        org.jetbrains.compose.web.dom.Text("FAQs and Info")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("faqs-and-info/how-to-write-a-support-request.md") {
                org.jetbrains.compose.web.dom.Text("How to Write a Support Request")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("faqs-and-info/can-i-create-a-free-server.md") {
                org.jetbrains.compose.web.dom.Text("Can I Create a Free Server?")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("faqs-and-info/my-server-is-suspended.md") {
                org.jetbrains.compose.web.dom.Text("My Server is Suspended")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("faqs-and-info/nodes-ip-and-information.md") {
                org.jetbrains.compose.web.dom.Text("Nodes IP & Information")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("faqs-and-info/payment-guide.md") {
                org.jetbrains.compose.web.dom.Text("Payment Guide")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("faqs-and-info/issues-creating-server-free-users.md") {
                org.jetbrains.compose.web.dom.Text("Issues Creating Server [Free Users]")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("faqs-and-info/premium-support-and-nodes.md") {
                org.jetbrains.compose.web.dom.Text("Premium Support & Nodes")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("faqs-and-info/account-server-recovery.md") {
                org.jetbrains.compose.web.dom.Text("Account/Server Recovery")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("faqs-and-info/running-installer.md") {
                org.jetbrains.compose.web.dom.Text("Running Installer")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("faqs-and-info/do-not-upload-node_modules.md") {
                org.jetbrains.compose.web.dom.Text("Do not upload node_modules")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("faqs-and-info/why-didnt-i-receive-coins-after-inviting-to-register.md") {
                org.jetbrains.compose.web.dom.Text("Why didn't I receive coins after inviting to register?")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("faqs-and-info/available-server-plans.md") {
                org.jetbrains.compose.web.dom.Text("Available Server Plans")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("community-resources") }) {
        org.jetbrains.compose.web.dom.Text("Community Resources")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("community-resources/node-and-website-uptime-monitor.md") {
                org.jetbrains.compose.web.dom.Text("Node & Website Uptime Monitor")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("community-resources/bananaburner-panel.md") {
                org.jetbrains.compose.web.dom.Text("BananaBurner Panel")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("community-resources/useful-repositories.md") {
                org.jetbrains.compose.web.dom.Text("Useful Repositories")
            }
        }
    }
}
